/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Sso_X15_ConflictInputs */



/**
* | output |
* | --- |
* | "This address is already linked to another person in the workspace. Ask your admin to check it." |
*
* @param {Signin_Sso_X15_ConflictInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const signin_sso_x15_conflict = /** @type {((inputs?: Signin_Sso_X15_ConflictInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Sso_X15_ConflictInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("This address is already linked to another person in the workspace. Ask your admin to check it.")
});